<template>
  <div class="window-height">
    <q-inner-loading showing color="secondary" />
  </div>
</template>
